import { Box, Button, Form, TextInput, Text, Grid, Image, Stack } from "grommet";
import React, { useEffect } from "react";

import axios from "../general/HttpClient";
import { Route, Routes, useNavigate } from "react-router-dom";
import { SignalRContext } from "./Admin";
import Login from "./Login";
import Subject from "./Subject";
import SkeletonWrapper from "../components/SkeletonWrapper";
import { Gallery } from "react-grid-gallery";
import QRCodeView from "../components/QRCodeView";

const Mirror = () => {
    const [subject, setSubject] = React.useState({} as any);
    const [loading, setLoading] = React.useState(true);
    const [photos, setPhotos] = React.useState([] as any[]);
    const [files, setFiles] = React.useState([] as any[]);

    SignalRContext.useSignalREffect(
        "Mirror",
        async (message) => {
            let response = await axios.get("/api/Subject/" + message);
            if (response.data) {
                load(message);
                // setSubject(response.data);
                // setLoading(false);
                // setPhotos(response.data.sharePhotos.map((sharePhoto) => ({ src: sharePhoto })));
            }
        },
        []
    );

    const [connectionId, setConnectionId] = React.useState("");

    SignalRContext.useSignalREffect(
        "Connected",
        async (message) => {
            setConnectionId(message);
        },
        []
    );

    const load = async (id) => {
        try {
            let response = await axios.get("/api/Subject/" + id);
            if (response.data) {
                setSubject(response.data);

                let files = [] as any[];

                // for (let i = 0; i < response.data.sharePhotos.length; i++) {
                //     let blob = await fetch(response.data.sharePhotos[i]).then((res) => res.blob());
                //     var image = new Image();
                //     image.src = URL.createObjectURL(blob);
                //     files.push(
                //         new Promise((resolve, reject) => {
                //             image.onload = () => {
                //                 resolve({ image, src: response.data.sharePhotos[i] });
                //             };
                //         })
                //     );
                // }

                // let values = await Promise.all(files);
                let photos = response.data.sharePhotos.map((src) => ({ src: src, width: 100, height: 100 }));
                setPhotos(photos);
                console.log(photos);
                setFiles(files);
                setLoading(false);
            }
        } catch (e) {
            setPhotos([]);
            setLoading(true);
        }
    };

    useEffect(() => {}, []);

    return (
        <Stack guidingChild={1} fill style={{ overflow: "hidden" }}>
            <Image fill src="/gallery.jpg" style={{ opacity: 0.4 }}></Image>
            <Box fill>
                <Box pad={"small"} style={{ position: "fixed" }}>
                    <Image src="/logo.png" width={"500px"}></Image>
                    <Text color="background-front">{connectionId}</Text>
                </Box>
                <SkeletonWrapper loading={loading}>
                    <Box pad={"small"} round="10px" align="center" gap="small">
                        <Text size="xlarge">{subject.name}</Text>
                        <QRCodeView text={"https://" + window.location.host + "/view/" + subject.id} size={300}></QRCodeView>
                        <Grid columns={{ count: photos.length > 4 ? 4 : photos.length, size: "auto" }} gap={"large"}>
                            {photos.map((photo) => (
                                <Image key={photo.src} src={photo.src} style={{ maxHeight: "450px" }}></Image>
                            ))}
                        </Grid>
                    </Box>
                </SkeletonWrapper>
            </Box>
        </Stack>
    );
};

export default Mirror;
